import { z } from 'zod';

export const completeEnglishIqV1RequestSchema = z.object({
  token: z.string().min(1),
});

export type ICompleteEnglishIqV1Request = z.infer<typeof completeEnglishIqV1RequestSchema>;
